import React from 'react';
import { useTranslation } from 'react-i18next';
import { MixerHorizontalIcon } from '@radix-ui/react-icons';
import { Select } from '@/shared/ui';
import { Switch } from '@/shared/ui/components/shadcn/switch';
import type { PropertyFilters } from './constants';
import { FURNISHED_OPTIONS, FACING_OPTIONS } from './constants';
import { SectionHeader, FieldLabel } from './parts';

interface Props {
  filters: PropertyFilters;
  setFilters: (f: PropertyFilters) => void;
}

export const FilterSectionAttributes: React.FC<Props> = ({ filters, setFilters }) => {
  const { t } = useTranslation('features/properties');

  const furnishedData = FURNISHED_OPTIONS.map((token) => ({
    value: token,
    label: t(`form.options.furnished.${token}`, { defaultValue: token }),
  }));

  const facingData = FACING_OPTIONS.map((token) => ({
    value: token,
    label: t(`form.options.facing.${token}`, { defaultValue: token }),
  }));

  return (
    <div>
      <SectionHeader icon={<MixerHorizontalIcon width={14} height={14} />} title={t('filterPanel.attributes')} />
      <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-3)' }}>
        <Switch
          checked={filters.petFriendly ?? false}
          onChange={(v) => setFilters({ ...filters, petFriendly: v })}
          label={t('filterPanel.petFriendly')}
          size="sm"
        />
        <Switch
          checked={filters.hasVirtualTour ?? false}
          onChange={(v) => setFilters({ ...filters, hasVirtualTour: v })}
          label={t('filterPanel.hasVirtualTour')}
          size="sm"
        />
        <Switch
          checked={filters.exchange ?? false}
          onChange={(v) => setFilters({ ...filters, exchange: v })}
          label={t('filterPanel.exchange')}
          size="sm"
        />
        <Switch
          checked={filters.imported ?? false}
          onChange={(v) => setFilters({ ...filters, imported: v })}
          label={t('filterPanel.imported')}
          size="sm"
        />
        <div>
          <FieldLabel>{t('filterPanel.furnished')}</FieldLabel>
          <Select
            data={furnishedData}
            value={filters.furnished || null}
            onChange={(v: string | string[] | null) => setFilters({ ...filters, furnished: Array.isArray(v) ? v[0] : (v ?? '') })}
            placeholder={t('filterPanel.selectOption')}
          />
        </div>
        <div>
          <FieldLabel>{t('filterPanel.facing')}</FieldLabel>
          <Select
            data={facingData}
            value={filters.facing || null}
            onChange={(v: string | string[] | null) => setFilters({ ...filters, facing: Array.isArray(v) ? v[0] : (v ?? '') })}
            placeholder={t('filterPanel.selectOption')}
          />
        </div>
      </div>
    </div>
  );
};
